export const footerLinks = [
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms of Use", href: "/terms-of-use" },
];

export const companyInfo = {
  name: "COMTRACKED LTD.",
  address: "128 City Road, London, United Kingdom, EC1V 2NX",
};
